import React from 'react';
import { useTheme, Paper, Stack, Typography } from '@mui/material';
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import StarIcon from '@mui/icons-material/Star';

import ISODateTime from 'components/formatting/ISODateTime';
import ISORelativeDateTime from "components/formatting/ISORelativeDateTime";
import { DashboardDocument } from './DashboardDocument';

export interface DashboardRowProps {
  dashboard: DashboardDocument;
  selectedDashboardId?: string;

  onClick?: (dashboard: DashboardDocument | undefined) => void;
}

export default function DashboardRow(props: DashboardRowProps): JSX.Element {
  const theme = useTheme();
  const { i18n } = useTranslation();
  
  // Only show year if it is not the current year
  const createdAtFormat = props.dashboard?.created_at && (new Date().getFullYear()) === dayjs(props.dashboard.created_at).year()
    ? { month: "long", day: "numeric" }
    : { year: "numeric", month: "long", day: "numeric" };

  return (
    <Paper sx={{
      mb: 1,
      p: 1,
      pl: 2,
      position: "relative",
      cursor: props.onClick ? "pointer" : "",
      border: props.selectedDashboardId === props.dashboard.id ? "2px solid " + theme.palette.primary.main : "none",
      "&:hover": {
        backgroundColor: props.onClick ? theme.palette.action.hover : "",
      },
     }}
     onClick={() => props.onClick && props.onClick(undefined)}
     >
      <Stack direction="row" sx={{
        gap: 0.5
      }}>
      <Typography variant="h4" sx={{p: 0, m:0}}>
        {props.dashboard.name}
      </Typography>
      {props.dashboard.is_favorite &&
        <StarIcon fontSize="small" sx={{ color: "gold" }} />
      }
      </Stack>
      <Typography>
        {props.dashboard?._user?.name}
      </Typography>
      {props.dashboard.description &&
        <>
          {props.dashboard.description.length < 200 ?
            <Typography>{props.dashboard.description}</Typography> :
            <Typography>{props.dashboard.description.substring(0, 200)}…</Typography>
          }
        </>
      }
      <Typography sx={{ color: theme.palette.text.secondary }}>
        <Stack direction="row" sx={{
          gap: .5
        }}>
          <ISODateTime
            isoString={props.dashboard.created_at}
            sx={{fontWeight:"bold"}}
            format={createdAtFormat}
          />
          {props.dashboard.updated_at && props.dashboard.updated_at != props.dashboard.created_at && <>
            <Typography>{i18n.t("updated").toLowerCase()}</Typography>
            <Typography sx={{
              fontWeight: "bold"
            }}>
              <ISORelativeDateTime isoString={props.dashboard.updated_at} />
            </Typography>
          </>}
        </Stack>
      </Typography>
    </Paper>
  );
}
